export default class AddressFormVM {
    _siDo;
    _siGunGu;
    _dong;
    _li;
    _jibun;
    _road;
    _enclosedRoad;
    _buildingNumber;
    _buildingName;
    _detail;
    _memo;
    _location;
    constructor({ siDo = '', siGunGu = '', dong = '', li = '', jibun = '', road = '', enclosedRoad = '', buildingNumber = '', buildingName = '', location = {
        longitude: '',
        latitude: '',
    }, detail = '', memo = '', }) {
        this._siDo = siDo;
        this._siGunGu = siGunGu;
        this._dong = dong;
        this._li = li ?? '';
        this._jibun = jibun ?? '';
        this._road = road ?? '';
        this._buildingNumber = buildingNumber ?? '';
        this._buildingName = buildingName;
        this._location = location;
        this._detail = detail;
        // TODO 지도관제 기획에서는 도로명에 괄호를 했으나 현재는 리 정보 여부에 따라 괄호 적용 여부가 달라진다, 추후 제거 필요
        // https://barogo.slack.com/archives/C02GJBMBU6B/p1693814053220769
        this._enclosedRoad = enclosedRoad;
        this._memo = memo;
    }
    get siDo() {
        return this._siDo;
    }
    get siGunGu() {
        return this._siGunGu;
    }
    get dong() {
        return this._dong;
    }
    get li() {
        return this._li;
    }
    get buildingName() {
        return this._buildingName;
    }
    get jibun() {
        return this._jibun;
    }
    // changeDropInfo action
    // https://qc-zoo-client-api.barogo.io/docs/api-guide.html#_5_3_%EC%A3%BC%EB%AC%B8_%EB%8F%84%EC%B0%A9%EC%A7%80_%EC%A0%95%EB%B3%B4_%EC%88%98%EC%A0%95
    // 5.3. 주문 도착지 정보 수정의 경우 dong이 아니라 eupMyeonDong으로 요청을 보내야 한다
    get eupMyeonDong() {
        return this._dong;
    }
    get buildingNumber() {
        return this._buildingNumber;
    }
    get mainBuildingNumber() {
        return this._buildingNumber.split('-')[0];
    }
    get subBuildingNumber() {
        return this._buildingNumber.split('-')[1];
    }
    get mainLandNumber() {
        return this._jibun.split('-')[0];
    }
    get subLandNumber() {
        return this._jibun.split('-')[1];
    }
    get ri() {
        return this._li;
    }
    get jibunAddress() {
        return this._jibun;
    }
    get roadName() {
        return this._road;
    }
    get location() {
        return this._location;
    }
    set location(value) {
        this._location = value;
    }
    get detail() {
        return this._detail;
    }
    set detail(value) {
        this._detail = value;
    }
    get memo() {
        return this._memo;
    }
    set memo(value) {
        this._memo = value;
    }
    get addressDetail() {
        return this._detail;
    }
    setAddressFormData(newData = {
        siDo: '',
        siGunGu: '',
        dong: '',
        li: '',
        jibun: '',
        road: '',
        enclosedRoad: '',
        buildingNumber: '',
        buildingName: '',
        location: {
            longitude: '',
            latitude: '',
        },
        detail: '',
        memo: '',
    }) {
        Object.assign(this, newData);
    }
    /**
     * formatted address base of li convertor
     * @param {string} formatType 시/도 가 포함된 풀주소여부 (default는 시/도가 제외된 shorten)
     * @param {boolean} includeDetail 상세주소 포함할지 여부
     * @returns {string} formatted address
     */
    formattedAddressBasedOfLi = (formatType = 'shorten', includeDetail = true) => {
        const { _siDo, _siGunGu, _dong, _li, _jibun, _road, _buildingNumber, _buildingName, _detail, } = this;
        // '리' 정보가 없을 경우,
        // 도로명 + 건물번호 + "("+ 읍/면/동 + 지번 + ")," + 건물명 + 상세주소
        // 예) 학동로 47길 20 (논현동 117), 씨엔에스빌딩 101동 101호
        let addressDataTempList = [
            _road,
            _buildingNumber,
            '(',
            _dong,
            _jibun,
            ')',
            ',',
            '),',
            _buildingName,
        ];
        if (includeDetail) {
            addressDataTempList.push(_detail);
        }
        if (!_dong && !_jibun) {
            addressDataTempList = addressDataTempList.filter((text) => text !== '(' && text !== ')' && text !== '),');
        }
        if (!_buildingName && !_detail) {
            addressDataTempList = addressDataTempList.filter((text) => text !== ',' && text !== '),');
        }
        if ((_dong || _jibun) && (_buildingName || _detail)) {
            addressDataTempList = addressDataTempList.filter((text) => text !== ')' && text !== ',');
        }
        // '리' 정보가 있을 경우,
        // 읍/면/동 + 도로명 + 건물번호 + "("+ 리 + 지번 + ")," + 건물명 + 상세주소
        // 예) 흥해읍 새마을로 331-6 (대련리 66-5), 씨엔에스빌딩 101동 101호
        if (_li) {
            addressDataTempList = [
                _dong,
                _road,
                _buildingNumber,
                '(',
                _li,
                _jibun,
                ')',
                ',',
                _buildingName,
            ];
            if (includeDetail) {
                addressDataTempList.push(_detail);
            }
            if (!_dong && !_jibun) {
                addressDataTempList = addressDataTempList.filter((text) => text !== '(' && text !== ')' && text !== '),');
            }
            if (!_buildingName && !_detail) {
                addressDataTempList = addressDataTempList.filter((text) => text !== ',' && text !== '),');
            }
            if ((_dong || _jibun) && (_buildingName || _detail)) {
                addressDataTempList = addressDataTempList.filter((text) => text !== ')' && text !== ',');
            }
        }
        // formatType이 full 일경우 시/도 추가되어야 함
        if (formatType === 'full') {
            addressDataTempList.unshift(_siDo, _siGunGu);
        }
        const validAddressDataList = addressDataTempList.filter((it) => !!it);
        if (validAddressDataList.length === 0) {
            return '';
        }
        const result = validAddressDataList.join(' ').trim();
        if (result[0] === ',') {
            return result.replace(',', '');
        }
        if (result === ',') {
            return '';
        }
        // 주소 등록 시 카카오 api로 가져온 주소데이터에 건물명이 없을 때 _detail은 사용자가 상세주소 input에 따로 입력하는 경우, 주소검색 결과 보여주는 input 주소 뒤에 불필요한 쉼표가 붙지 않도록 하기
        const lastResultString = result[result.length - 1];
        if (lastResultString === ',') {
            return result.replace(',', '');
        }
        return result.replace('( ', '(').replace(' )', ')');
    };
}
